import { CPSConstants } from "commonUtils/enumerations";

export interface ContentNoteTypeConfigRecordsProps {
  noteTypeId: number;
  codeId: string;
  noteTypeDesc: string;
  memo: string;
  status: string;
}

export interface RelationshipsProps {
  id: number;
  name: string;
}

export interface AddEditContactNoteTypeDataProps {
  relationshipId: number;
  status: boolean;
  typeId: string;
  noteType: string;
  memo: string;
  userDetails: string | undefined | null;
  messageCode: number;
  message: number;
  isSuccessMessage: boolean;
  isErrorMessage: boolean;
  isValidationMessage: boolean;
}

export interface AddEditContactNoteTypeSubmitProps {
  noteTypeId: number;
  relationshipId: number;
  status: true;
  typeId: string;
  noteType: string;
  memo: string;
  profileId: number;
  switchedProfileId: number;
}

export const adminStyles = {
  paddingLeftZeroPointFive: {
    pl: 0.5,
  },
  fontFamilyCSS: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
  },
  masterContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "20px",
    "& input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#fff",
    },
    marginLeft: "0px !important",
  },
  marginRight10px: {
    marginRight: "10px",
  },
  marginTop10px: {
    marginRight: "10px",
    marginTop: "10px",
  },
  typoGraphyHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "0.5rem",
    textAlign: "left",
    fontWeight: "500",
    fontSize: "1.4rem",
  },
  boxFontStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1.4rem",
    fontWeight: "500",
    display: "flex",
    gap: "0rem",
    marginBottom: "0rem",
    marginleft: "0rem",
  },

  dataGridStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiDataGrid-columnHeader": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#C1EA94",
      paddingLeft: "3px",
    },
    "& .MuiDataGrid-columnHeaders .MuiDataGrid-withBorderColor": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      borderRight: "1px solid #a9cb83",
    },
    "& .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.MuiDataGrid-columnHeader--sorted.MuiDataGrid-withBorderColor":
    {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#9dd262",
      "& .MuiDataGrid-columnHeaderTitle": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        fontWeight: "bold",
      },
    },
    "& .MuiDataGrid-columnHeaderDraggableContainer": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "flex",
      padding: "2px",
    },
    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      fontWeight: "normal",
    },
    "& .MuiDataGrid-colCell": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "auto",
    },
    "& .MuiDataGrid-row": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      "& .MuiDataGrid-cell": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        padding: "5px 5px",
        lineHeight: "normal !important",
        whiteSpace: "normal !important",
        wordWrap: "break-word",
      },
    },
    "& .MuiDataGrid-footerContainer.MuiDataGrid-withBorderColor": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& .MuiTablePagination-selectLabel": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
      },
      "& .MuiSelect-select": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        "& .MuiPaper-root MuiPaper-elevation MuiPaper-rounded": {
          fontFamily: CPSConstants.FONT_FAMILY as string,
        },
        "& .MuiPopover-paper.MuiMenu-paper.MuiMenu-paper": {
          fontFamily: CPSConstants.FONT_FAMILY as string,
        },
      },
      "& .MuiTablePagination-displayedRows": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
      },
    },
  },
  dataGridWrapper: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "auto",
    width: "100%",
    paddingTop: "1rem",
    display: "grid",
    gridTemplateColumns: "1fr",
  },
  typoGraphy: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "0.5rem",
    textAlign: "left",
    fontWeight: "500",
    fontSize: "1rem",
  },
  headers: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#9cf",
    paddingRight: "5px",
  },
  adminTabsTittleContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderBottom: "1px solid #d0d0d0",
    width: "100%",
    marginBottom: "15px",
  },
  metadataCustomTab: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minHeight: "30px",
    ".MuiButtonBase-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "1px",
      minWidth: "60px",
      minHeight: "30px",
    },
    ".MuiTabs-indicator": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "transparent",
    },
    ".Mui-selected": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: 600,
    },
  },
  tabsCapitalize: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textTransform: "capitalize",
  },
  tabsMetadataCustom: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "1.5rem !important",
    position: "relative",
    "&:after": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      content: "''",
      position: "absolute",
      top: "14px",
      right: "4px",
      width: "3px",
      height: "3px",
      backgroundColor: "#050505",
      borderRadius: "50%",
    },
    ":last-child::after ": {
      display: "none",
      fontFamily: CPSConstants.FONT_FAMILY as string,
    },
  },
  textFieldMediumSize: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "95%",
  },
  adminTextField: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "100%",
  },
  boxGridCheckBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "&.Mui-checked": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#9dd262",
    },
  },
  multiSelectSearchOwnerShipDropdownWidth: {
    ".MuiFormControl-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      width: "100% !important",
    },
  },
  multiSelectWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "27.5rem",
  },
  multiCustomSelectWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "45.9rem",
  },
  multiCustomSelectWidth45point2rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "45.2rem",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  multiTabCustomSelectWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "21.9rem",
  },
  multiTabCustomScreeningSelectWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "21rem",
  },
  multiSmallSelectWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "12.5rem",
  },
  multiCustomSelectWidth16point5rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "16.5rem",
  },
  multiSelectWidth25rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "25rem",
  },
  multiSelectWidth29P5rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "29.5rem",
  },
  uploadFileTextfieldStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& input": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        paddingLeft: "0px",
      },
      "& fieldset": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        border: "none",
      },
    },
  },
  widthTwentyFivePercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "25%",
  },
  widthThirtyPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "30%",
  },
  widthFifteenPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "15%",
  },
  widthTwentyPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "20%",
  },
  widthFiftyPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "50%",
  },
  widthHundrendPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
  },
  validationAlert: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0 0 1rem 0",
  },
  textMessageAlertDialogUL: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& ul": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingLeft: "12px",
      margin: "0",
      fontWeight: "bold",
      fontSize: "11px",
    },
    "& li": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingBottom: "4px",
      listStyleType: "decimal",
    },
  },
  textMessageUL: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& ul": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingLeft: "12px",
      margin: "0",
    },
    "& li": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingBottom: "4px",
      listStyleType: "disc",
      fontSize: "0.85rem",
    },
  },
  cursorPointer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    cursor: "pointer",
  },
  richTextEditorHeight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "30rem !important",
  },
  richTextQuestionsHeight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "6rem !important",
  },
  richTextAdditionalQHeight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "3rem !important",
  },
  cloneDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "45rem",
    padding: "0 0 10px 0",
  },
  surveyConfirmDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "35rem",
    padding: "0 0 10px 0",
  },
  surveyPaperPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "auto",
    minWidth: "20rem",
    minHeight: "10rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px 2.25rem !important",
    },
    "& .MuiDialogActions-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "0px 2.25rem 20px 2.25rem !important",
    },
  },
  cloneDialogContentStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "22px !important",
  },
  cloneDialogActionStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
  },
  adminCustomRadio: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "5px",
  },
  adminCustomRadioLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "24px",
    "& span": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: 800,
    },
  },
  marginLeftZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "0",
  },
  hyperLinkStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#0000EE",
    cursor: "pointer",
  },
  adminPrefrenceRadio: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "5px",
  },
  yesBoolean: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#0c3",
  },
  noBoolean: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "red",
  },
  fontFamily: CPSConstants.FONT_FAMILY as string,
  adminPrefrenceRadioLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "24px",
    "& span": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: 800,
    },
  },
  viewListSubmitbtn: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "2rem",
    display: "flex",
    justifyContent: "right",
  },
  viewQueueSubmitbtn: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    margintop: "1rem",
  },
  boxValidation: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "0rem",
  },
  adminLeftMultipleItemList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
  },
  multipleSelect: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiNativeSelect-select": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "2px 0px 2px 2px !important",
      height: "94px!important",
    },
  },
  menuItem: { fontFamily: "Montserrat" },
  MultipleItemListButtonsBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    marginLeft: "0.75rem",
    marginRight: "0.75rem",
    justifyContent: "center",
  },
  MultipleItemListButtonsPermisssionBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    marginTop: "30px",
    marginLeft: "0.75rem",
    marginRight: "0.75rem",
    justifyContent: "center",
  },
  adminRightMultipleItemList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
  },
  tabsSelected: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px solid #a9cb83",
    "& .MuiTab-textColorPrimary": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      textTransform: "capitalize",
    },
    "& .Mui-selected": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#000000 !important",
      fontSize: "1rem",
      textTransform: "capitalize",
    },
  },
  tabDesign: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#233274",
    height: 7,
    borderRadius: "5px 5px 0 0",
  },
  customTabPanelBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0px 5px",
    border: "1px solid #a9cb83",
  },
  paperPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    minHeight: "25rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropDeleteDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "37rem",
    minWidth: "37rem",
    minHeight: "20rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropHeight25remDialog: {
    minWidth: "10rem",
    minHeight: "25rem",
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  alignContentCenterFlex: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  boxPaddingAlertStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "0rem",
  },
  iconWarning: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "orange",
    fontSize: "3rem",
  },
  fontSize1rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
  },
  btnPlaceEvenly: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    paddingTop: "1rem",
  },
  marginLeftAuto: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "auto",
  },
  marginLeft6rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "6rem",
  },
  marginLeft3rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "3rem",
  },
  iconPadding: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "0.313rem",
  },
  approvedTextStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "green",
  },
  adminDataGridContianer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "10px 0 10px 0",
  },
  gridCellButtonAlignCenter: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  confirmDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "55rem",
    padding: "0 0 10px 0",
  },
  boxDDLValidation: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "0rem",
  },
  iframeContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "90rem",
    height: "40rem",
    width: "100%",
  },
  addEntityDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "80rem",
    minWidth: "70rem !important",
    minHeight: "40rem",
    padding: "0 0 10px 0",
  },
  pdfDocumentsIconsList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "4px",
  },
  paddingZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0",
  },
  brandsListPaddingLeft: { paddingLeft: "0.5rem" },
  addEditTooltipDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "80rem",
    padding: "0 0 10px 0",
    maxWidth: "800px",
  },
  dialogContentStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "22px !important",
  },
  hideTimeIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    ".MuiInputAdornment-positionEnd": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "none",
    },
  },
  timePckerPaddingIcon: {
    ".MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "4px",
      width: "100%",
    },
    ".MuiOutlinedInput-root input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "0.4rem",
    },
  },
  customTooltip: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "rgba(0, 0, 0, 0.87)",
    border: "5px solid lightgray",
    fontSize: 11,
  },
  InfoIconStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "0.5rem",
  },
  leftMultipleItemList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
  },
  rightMultipleItemList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
  },
  multipleSelectddl: {
    "& .MuiNativeSelect-select": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "2px 0px 2px 2px !important",
      height: "94px!important",
    },
  },
  cancelRow: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "45px",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginTop: "8px",
    "& .MuiIconButton-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      border: "1px solid black",
      borderRadius: 0,
      padding: "4px",
    },
  },
  normalText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: 800,
    lineHeight: 1.4,
  },
  textFieldColorFullWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "100%",
  },
  fullWithTextField: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "90%",
  },
  marginRight5px: {
    marginRight: "5px",
  },
  paperPropPreviewRequestFormDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "95rem",
    minHeight: "50rem",
    "& .MuiDialogContent-root": {
      p: "20px !important",
    },
  },
  customRequesForm: {
    padding: "2px 8px !important",
  },
  linkTextDecorationUnset: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textDecoration: "unset",
    color: "blue",
  },
  defaultFontFamily: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
  },
  displayBlock: {
    display: "block",
  },
  activityAssignmentsStyles: {
    border: "1px solid #9dd262",
    paddingRight: "8px",
    marginLeft: "0",
    paddingLeft: "0",
    width: "100%",
  },
  mailTextContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    wordWrap: "break-word",
    overflowWrap: "break-word",
    width: "100%",
  },
  expandSearch: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    alignItems: "center",
  },
  headerBackgroundcolor: {
    backgroundColor: "#9dd262",
  },
  fontWeightFiveHundred: {
    fontWeight: "500",
  },
  textAlignCenter: {
    textAlign: "center",
  },
  updateApproverInputStyle: {
    color: "rgba(0, 0, 0, 0.87)",
    WebkitTextFillColor: "unset",
  },
  widthThirtyFivePercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "35%",
  },
  screeningDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "5px 0px 0 0",
    fontStyle: "italic",
  },
  adminTextarea: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
    padding: "5px",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
  },
  paperPropCommentDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "95rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      p: "20px !important",
    },
  },
  parentTextarea: {
    ".textArea-auto": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      resize: "none",
    },
  },
  commonTextarea: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
    width: "100%",
    padding: "5px",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
  },
  commonSmallTextTextarea: {
    ".textArea-auto": {
      fontSize: "1rem !important",
      resize: "none",
    },
  },
  adminParentTextarea: {
    ".textArea-auto": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      resize: "none",
    },
  },
  SPPCommentpaperPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "40rem",
    minHeight: "15rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  columnBreakWord: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: "1.2",
    paddingTop: "0.313rem",
    paddingBottom: "0.313rem",
    fontWeight: "500",
  },
  costCenterpaperPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "95rem",
    minHeight: "35rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  acceptMsgDialogContentStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "22px !important",
  },
  outerBorder: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px solid #a9cb83",
  },
  facultyTextarea: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
    padding: "5px",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    fontSize: "12px",
  },
  facultyParentTextarea: {
    ".textArea-auto": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      resize: "none",
    },
  },
  QRCodePropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "35rem",
    minHeight: "52rem",
    maxHeight: "99%",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  addContactNoteDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "50rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "0px  1.25rem !important",
    },
  },
  containedButtonStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textTransform: "none",
    fontSize: "1rem",
  },
  customCMtypoGraphy: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
  },
  hideDatePckerIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    ".MuiInputAdornment-positionEnd": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "none",
    },
  },
  datePckerPaddingIcon: {
    ".MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingRight: "0",
      width: "100%",
    },
    ".MuiOutlinedInput-root input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "0.4rem",
    },
  },
  viewContractHistoryDialogPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "110rem",
    minHeight: "45rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  textTransformNone: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textTransform: "none",
    fontSize: "1rem",
  },
  customDataGridSortIconPosition: {
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      display: "block !important",
      padding: "4px 2px",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: "0.95rem",
    },
  },
  customSmallSelector: {
    ".MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
    {
      paddingRight: "10px !important",
    },
    ".MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "4.5px 6px !important",
    },
    ".MuiSvgIcon-root-MuiSelect-icon": {
      right: "2px !important",
    },
  },
  disabledTextField: {
    "& .MuiInputBase-root.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#f7f7f7",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      WebkitTextFillColor: "#003",
    },
  },
  smallUploadDialog: {
    maxWidth: "500px",
    minWidth: "40rem",
    minHeight: "14rem",
  },
  marginPaddingZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    margin: "0",
    padding: "0",
  },
  mediumSizeDialog600Width: {
    maxWidth: "600px",
  },
  customSmallSizeSelector: {
    p: 0,
    "& .MuiOutlinedInput-input": {
      p: 0,
      pr: 10,
      padding: "4px",
    },
    "& .MuiSelect-select.MuiSelect-outlined": {
      paddingRight: "10px",
    },
    "& .MuiSvgIcon-root": {
      right: "-1px",
    },
  },
  paperPropsViewAttachDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "100rem",
    minHeight: "45rem",
  },
  centerTheDialogContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
  },
  marginRightZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "0",
  },
  contractTemplateDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    minHeight: "30rem",
  },
  checkBoxEmailTemplate: {
    padding: "18px 8px",
  },
  textBoxDisabled: {
    "& .MuiInputBase-root.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#f0f0f0",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      WebkitTextFillColor: "#003",
    },
  },
  noteMessageItalic: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontStyle: "italic",
  },
  paperPropsEditFolderhDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "30rem",
    minHeight: "25rem",
  },
  disabledLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textDecoration: "none",
    pointerEvents: "none",
    cursor: "default",
    color: "gray",
  },
  paperPropDialogWidth90remHeight35rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "90rem",
    minHeight: "35rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  gridWordBreakCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: 1.5,
  },
  sendEmailCustomDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "85rem",
    minWidth: "90rem !important",
    minHeight: "50rem",
    padding: "0 0 10px 0",
  },
  viewApprovalRequiredDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    width: "40rem",
    minHeight: "30rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  innerTableStackStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    direction: "column",
    justifyContent: "center",
    alignItems: "stretch",
    spacing: 0,
    height: "100%",
    width: "100%",
  },
  paddingTopZero: {
    paddingTop: 0,
  },
  announcementConfigurationRulesDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    width: "50rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "10px !important",
    },
  },
  paperPropDialogWidth55remHeight20rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "55rem",
    minHeight: "20rem",
  },
  marginBottom5px: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "5px",
  },
  mainTableStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    margin: "10px 0 0 0",
    width: "100%",
  },
  tableDesign: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& tr:nth-child(even) ": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#ffffff",
    },
    "& th": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#000",
      border: "1px solid rgb(169, 203, 131)",
      background: "#0E2079",
      fontWeight: "bold !important",
      fontSize: "1rem",
      padding: "6px 8px",
    },
    "& td": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      border: "1px solid rgb(169, 203, 131)",
      fontWeight: "bold !important",
      fontSize: "1rem",
      padding: "6px 8px",
    },
  },
  tableHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "rgb(193, 234, 148) !important",
    "& tr": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8px",
    },
    "& th": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#000 !important",
      border: "1px solid rgb(169, 203, 131)",
      fontWeight: "bold",
      fontSize: "1rem",
      padding: "8px",
    },
    "& td": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: "bold !important",
    },
    fontWeight: "bold",
    fontSize: "1rem",
  },
  paddingLeft5px: {
    paddingLeft: "5px",
  },
  paddingLeft7px: {
    paddingLeft: "7px",
  },
  paddingLeft12px: {
    paddingLeft: "12px",
  },
  paddingLeft5pxWidth90Percent: {
    paddingLeft: "5px",
    width: "100%",
  },
  paddingLeft5pxWidth60Percent: {
    paddingLeft: "5px",
    width: "60%",
  },
  paddingLeft15px: {
    paddingLeft: "15px",
  },
  paddingRight5px: {
    paddingRight: "5px",
  },
  SelectBoxDisabled: {
    "& .Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#e5e5e5",
    },
  },
  headersColor: {
    color: "Blue",
  },
  tabPadding: {
    padding: "15px 10px",
  },
  checkboxPadding: {
    padding: "0 1px 0 0px",
  },
  paperPropWidth80remDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "80rem",
    minHeight: "25rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  automatedBusinessTaskInlineBlockStyles: {
    width: "50%",
    display: "inline-block",
    float: "left,",
  },
  multiSelectAdminInputStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "14px",
    width: "100%",
    overflow: "hidden",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  sectionBorder: {
    border: "1px solid #9dd262",
    paddingRight: "8px",
    marginLeft: "0",
    paddingLeft: "0",
    width: "100%",
  },
  searchSectionBorder: {
    border: "1px solid #9dd262",
  },
  AddEditMergeFieldTableDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "70rem",
    padding: "0 0 10px 0",
  },
  tableIconsStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "1.8rem",
    height: "1.8rem",
    marginRight: "4px",
  },
  noteForLogoStyles: {
    fontWeight: "bold",
    paddingTop: "0px !important",
    fontSize: "0.9rem",
  },
  noteStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "1.1rem",
    height: "2rem",
  },
  fileIconStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "1.3rem",
    height: "2rem",
  },
  paperPropsViewImgDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "20rem",
    minHeight: "10rem",
  },
  maxWidthFiftyRem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    maxWidth: "50rem",
  },
  descriptionIconDocx: {
    color: "#5f9afe",
    cursor: "pointer",
  },
  descriptionIconXlsx: {
    color: "#05af05",
    cursor: "pointer",
  },
  videoFileIcon: {
    color: "#ff0202",
    cursor: "pointer",
  },
  dialogContentManagmentPaperProps: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    minHeight: "30rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paddingLeftZero: {
    paddingLeft: "0",
  },
  userManagementButton18Width: {
    width: "18%",
  },
  userManagementButtonCustomPadding: {
    padding: 0,
    paddingLeft: 3,
  },
  paperPropSearchFRUserDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "75rem",
    minHeight: "45rem",
  },
  searchFormContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f1fae6",
    border: "1px solid #9dd262",
    borderRadius: "0 0 0.5rem 0.5rem",
    paddingTop: "1rem",
    paddingBottom: "0.5rem",
    width: "400px",
    minHeight: "200px",
    input: {
      background: "#fff",
    },
  },
  customSearchContainerTitle: {
    width: "400px",
    margin: "0 auto",
  },

  showSurveyStatsPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "100rem", // ~1440px
    maxWidth: "100rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      padding: "2rem !important",
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      padding: "4px 2px",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: "0.95rem",
    },

    // summary row styling
    "& .summary-row .MuiDataGrid-cell": {
      backgroundColor: "#f4fce3",
      fontWeight: "bold",
    },
    "& .summary-row .MuiDataGrid-cell[data-field='campaign']": {
      borderRight: "none !important",
    },
    "& .summary-row .MuiDataGrid-cell[data-field='sender']": {
      borderLeft: "none !important",
    },

  },
  addTargetUserpaperPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    minHeight: "45rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  borderBottomSolid: {
    borderBottom: "1.5px solid Blue",
    marginBottom: "2px",
  },
  marginRight15px: {
    marginRight: "15px",
  },
  greenBorderWithPadding: {
    border: "1px solid #cfefad",
    p: 2,
  },
  customH2Title: {
    "& .custom-title": {
      fontSize: "1.5rem",
      margin: "0",
      marginBottom: "0.5rem",
    },
  },
  addFolderIcon: {
    fontSize: "5rem",
    color: "#f6c35d",
    mr: 1,
  },
  addFileIcon: {
    fontSize: "5rem",
    color: "#f6c35d",
  },
  height100Percent: {
    height: "100%",
  },
  height50Percent: {
    height: "50%",
  },
  boldHyperLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#0000EE",
    cursor: "pointer",
    fontWeight: "bold",
  },
  boldGrayLink: {
    color: "#999",
    fontWeight: "bold",
    cursor: "pointer",
  },
  previewButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
    fontSize: "1rem",
    pointerEvents: "none",
    cursor: "default",
    userSelect: "none",
    opacity: 1,
    bgcolor: "#233274",
    textTransform: "none",
  },
  customInfoMargin: {
    marginLeft: "-4px !important",
  },
  customUserManagementBtn80Width: {
    width: "80%",
  },
  customUserManagementBtn95Width: {
    width: "95%",
  },
  customTierHeight: {
    lineHeight: "1.5",
    textAlign: "center",
  },
  honorariumAdminTierLevelDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "80rem",
    minHeight: "45rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  financialCategoryPaperPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "60rem",
    minHeight: "52rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  formerLillyDialogPaperPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "48rem",
    minHeight: "32rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  borderLeft: {
    borderLeft: "1px solid #9dd262",
  },
  borderBottom: {
    borderBottom: "1px solid #9dd262",
  },
  widthUnset: {
    width: "unset",
  },
  paddingTopZeroPX: {
    paddingTop: "0px",
  },
  verticalLine: {
    borderLeft: "1px solid #ccc",
    height: "100%",
    marginLeft: 3,
  },
  activityDescTextarea: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
    padding: "5px",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    fontSize: "1rem",
  },
  activityDescriptionPaperPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "65rem",
    minHeight: "25rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  muiFormControlLabelFontFamily: {
    "& .MuiFormControlLabel-label": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
    },
  },
  paperPropDialogAlert: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "40rem",
    minHeight: "15rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "35px !important",
    },
  },
  stackPaddingTop: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    justifyContent: "center",
    paddingTop: "1rem",
  },
  contentManagementFileDialogFieldSet: {
    border: "1px solid #9dd262",
    marginBottom: "10px",
  },
  wordBreakwhiteSpace: {
    wordBreak: "break-word",
    whiteSpace: "normal",
  },
  formerLillyDialogCharacterLimit: {
    margin: "-12px 0 0 0",
  },
  displayFlexJustifyContentRight: {
    display: "flex",
    justifyContent: "right",
  },
  groupSelectCheckbox: {
    pl: 4,
  },
  paperPropUpSurveyPreviewDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "85rem",
    minHeight: "20rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px 2rem !important",
    },
  },
  characterLimitLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textAlign: "right",
    color: "#666",
    marginTop: "4px",
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: "bold",
  },
  ratingScaleBox: {
    pl: "3rem",
    pr: "3rem",
    pb: "4rem",
  },
  numericScaleBox: {
    pl: "3rem",
    pr: "3rem",
    pb: "1rem",
  },
  ratingScale: {
    height: 8,
    width: "100%",
    "& .MuiSlider-thumb": {
      width: 24,
      height: 24,
      marginLeft: "5px",
    },
    "& .MuiSlider-mark": {
      height: 12,
      width: 12,
      borderRadius: "50%",
      top: "50%",
      transform: "translateY(-50%)",
    },
    "& .MuiSlider-markLabel": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: "1rem",
      whiteSpace: "normal !important",
      maxWidth: "5rem",
      textAlign: "center",
      pt: "1rem",
      fontWeight: "bold",
      marginLeft: "6px",
    },
    "& .MuiSlider-valueLabel": {
      fontSize: "1rem",
      textAlign: "center",
      maxWidth: "8rem",
      whiteSpace: "normal !important",
    },
  },
  ratingScaleNoValue: {
    height: 8,
    width: "100%",
    "& .MuiSlider-thumb": {
      width: 12,
      height: 12,
      marginLeft: "5px",
    },
    "& .MuiSlider-mark": {
      height: 12,
      width: 12,
      borderRadius: "50%",
      top: "50%",
      transform: "translateY(-50%)",
    },
    "& .MuiSlider-markLabel": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: "1rem",
      whiteSpace: "normal !important",
      maxWidth: "5rem",
      textAlign: "center",
      pt: "1rem",
      fontWeight: "bold",
      marginLeft: "6px",
    },
    "& .MuiSlider-valueLabel": {
      fontSize: "1rem",
      textAlign: "center",
      maxWidth: "8rem",
      whiteSpace: "normal !important",
    },
  },
  tableGridQuestionHeaderCellButtomBorder: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderBottom: "1px #bbbbbb solid",
    padding: "5px",
    fontWeight: "bold",
    textAlign: "center",
    width: "60%",
  },
  surveyTitleContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginButtom: "5px",
    fontSize: "1.4rem",
  },
  surveyTitle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "5px",
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "1.4rem",
    // position: "absolute",
    // left: "50%",
    // transform: "translate(-50%)",
  },
  surveyQuestionCounter: {
    padding: "5px",
    color: "#0E2079",
    textAlign: "right",
    fontWeight: "bold",
    fontSize: "1rem",
  },
  surveyQuestionNumber: {
    padding: "5px 0px 0px 0px",
    color: "#ababab",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "1rem",
  },
  tableGridQuestionHeaderCellP: {
    "& p": {
      whiteSpace: "normal",
      overflowWrap: "anywhere",
      wordBreak: "keep-all",
    },
  },
  tableGridQuestionHeaderCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px #bbbbbb solid",
    padding: "5px",
    backgroundColor: "#C1EA94",
    fontWeight: "bold",
    textAlign: "center",
    width: "8rem",
    fontSize: "1rem",
  },
  tableGridQuestionCell: {
    border: "1px #bbbbbb solid",
    padding: "5px",
    backgroundColor: "#C1EA94",
    fontSize: "1rem",
  },
  formHelperErrorText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
  },
  tableGridQuestionResponseCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px #bbbbbb solid",
    padding: "5px",
    textAlign: "center",
  },
  tableGridQuestionReasonCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px #bbbbbb solid",
    padding: "5px",
  },
  surveyBUMultiSelectInput: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: " bold",
    paddingRight: "14px",
    width: "100%",
    maxWidth: "75rem",
    overflow: "hidden",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  surveyBUCampaignMultiSelectInput: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: " bold",
    paddingRight: "14px",
    width: "235px",
    maxWidth: "235px",
    overflow: "hidden",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  mcqContainer: {
    display: "flex",
    gap: "20px",
  },

  mcqColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },

  mcqOption: {
    minWidth: "60ch",
    padding: "5px 5px",
    borderRadius: "8px",
    height: "40px",
    background: "#ffffff",
    border: "2px solid #d0d0d0",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontFamily: CPSConstants.FONT_FAMILY as string,
  },

  mcqOptionSelected: {
    border: "2.5px solid #1976d2 !important",
  },

  mcqLabel: {
    marginLeft: "8px",
    flexGrow: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    fontWeight: "bold",
    textOverflow: "ellipsis",
    fontFamily: CPSConstants.FONT_FAMILY as string,
  },

  mcqTooltipIcon: {
    fontSize: "16px",
    color: "#1976d2",
    marginLeft: "6px",
    cursor: "pointer",
  },

  mcqOtherTextbox: {
    marginTop: "15px",
    fontFamily: CPSConstants.FONT_FAMILY as string,
  },

  addSurveyTargetUserDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "100rem", // ~1440px
    maxWidth: "100rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      padding: "2rem !important",
    },
  },
  multipleSelectddlfullWidth: {
    "& .MuiNativeSelect-select": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "2px 0px 2px 2px !important",
      height: "150px !important",
      overflowY: "auto",
    },
  },
  questionMenuItem: {
    fontFamily: "Montserrat",
    whiteSpace: "normal",
  },
  fullWithSpaceBetween: {
    flexGrow: 1,
    boxSizing: "border-box",
    justifyContent: "space-between",
  },
  surveyStatsBoxStyle: {
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '4px 10px',
    minWidth: '60px',
    backgroundColor: '#fff',
    textAlign: 'center',
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
  },
  surveyEmailBoxStyle: {
    padding: '4px 10px',
    width: '80px',
    textAlign: 'center',
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
  },
  surveyStatsLabelStyle:
  {
    whiteSpace: 'nowrap',
    minWidth: '190px',
    fontWeight: 'bold'
  },
  surveyEmailLabelStyle:
  {
    whiteSpace: 'nowrap',
    minWidth: '100px',
    fontWeight: 'bold'
  },
  userProfileStyleCpsLogo: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "12rem",
    background: "#001444",
    borderRadius: "2px",
    },
  surveyTitleSection: {
    display: "grid",
    gridTemplateColumns: "auto 1fr auto",
    justifyItems: "center",
    alignItems: "center"
  },
  
 disablePreviewLinks: {
    "& a": {
      pointerEvents: "none",
      cursor: "default",
      textDecoration: "underline",
    },
  },

  richTextCustomFontcolors: {
    columns: 10,
    colorCode: {
      'Custom': [
        '', '#000000', '#e7e6e6', '#44546a', '#0000ffff', '#ed7d31', '#a5a5a5', '#ffc000', '#70ad47', '#ff0000',
        '#f2f2f2', '#808080', '#cfcdcd', '#d5dce4', '#000080', '#fbe4d5', '#ededed', '#fff2cc', '#e2efd9', '#ffcccc',
        '#d9d9d9', '#595959', '#aeaaaa', '#acb9ca', '#0707FF', '#f7caac', '#dbdbdb', '#ffe599', '#c5e0b3', '#ff8080',
        '#bfbfbf', '#404040', '#747070', '#8496b0', '#3333ffff', '#f4b083', '#c9c9c9', '#ffd966', '#a8d08d', '#ff3333',
        '#a6a6a6', '#262626', '#3b3838', '#323e4f', '#000099ff', '#c45911', '#7b7b7b', '#bf8f00', '#538135', '#b30000',
        '#7f7f7f', '#0d0d0d', '#161616', '#212934', '#000066ff', '#823b0b', '#525252', '#7f5f00', '#375623', '#660000',]
    }
  },
  nextButton: {
    backgroundColor: "#233274",
    color: "white",
    padding: "6px 16px",
    fontSize: "0.875rem",
    minWidth: "64px",
    fontWeight: 600,
    lineHeight: 1.75,
    border: "none",
    borderRadius: "4px",
    textTransform: "uppercase" as const,
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    float: "right" as const,
    marginTop: "10px",
  },
    multiLineHeaderText: {
        lineHeight: 1.4,
        fontWeight: 500,
    },
    multiLineCellText: {
        lineHeight: 1.4,
    },
     inputTextAlignRight: {
    textAlign: "right",
    direction: "rtl",
    unicodeBidi: "plaintext",
  },
  contentManagementTreePanel: {
      overflow: "auto",
      height: "800px",
    }
};
